import { SubmitHandler } from "react-hook-form";
import { z } from "zod";
import { staticText as sharedText } from "../../../statics/static-text";

// TEXT
export const text = {
  shared: { buttons: sharedText.buttons, inputs: sharedText.inputs },
};

// STYLES

// DATA

// TYPES
type ModalText = {
  header: string;
  description: string;
  placeholder: string;
};

export type Props = {
  text: ModalText;
  onSubmit: AdminNotesModalSubmit;
  urlParam?: string;
  disabled?: boolean;
  open?: boolean;
  onClose?: () => void;
};

export type AdminNotesModalSubmit = SubmitHandler<FormFields>;

export type FormFields = z.infer<typeof schema>;

// CONSTANTS
export const schema = z.object({
  [text.shared.inputs.adminNotes.id]: z
    .string()
    .min(1, text.shared.inputs.adminNotes.validation.required),
});

// FUNCTIONS

// ASSETS
